import { apiV2WaterMapConfigDetailPost, apiV2WaterMapConfigSavePost } from '@maxtropy/device-customer-apis-v2';

export const areaTable = [
  {
    key: '1',
    elementNo: '1#',
    type: '流量计',
    action: '关联节点',
  },
  {
    key: '2',
    elementNo: '2#',
    type: '流量计',
    action: '关联节点',
  },
  {
    key: '3',
    elementNo: '中水站',
    type: '水务站房',
    action: '关联用能单元',
  },
  {
    key: '4',
    elementNo: '污水站',
    type: '污水站房',
    action: '关联用能单元',
  },
  {
    key: '5',
    elementNo: '自来水站',
    type: '水务站房',
    action: '关联用能单元',
  },
];

// 获取水务配置详情
export async function fetchWaterConfigDetail(form: any, setCurrentUnitData: Function) {
  const res = await apiV2WaterMapConfigDetailPost({});
  form.setFieldsValue({
    unWorkTime: res.periodId,
    waterConfig: res.configurationId,
    energyTopology: res.topologyId,
    pipeLossNode: res.nodeIds,
    symbolDisplay: res.symbolDisplay ?? true,
    deviceLabel: res.labelIds,
    energyUnitName1: res.energyUnitName1,
    energyUnitName2: res.energyUnitName2,
    energyAnalysisGroup1: res.energyUnitGroupReqs?.[0]?.energyGroupId,
    levelRange1: {
      fromLevel: res.energyUnitGroupReqs?.[0]?.fromLevel,
      toLevel: res.energyUnitGroupReqs?.[0]?.toLevel,
    },
    mediumSelection1: res.energyUnitGroupReqs?.[0]?.mediumId,
    displayEnergyName1: res.energyUnitGroupReqs?.[0]?.showEnergyGroupName,
    energyAnalysisGroup2: res.energyUnitGroupReqs?.[1]?.energyGroupId,
    levelRange2: {
      fromLevel: res.energyUnitGroupReqs?.[1]?.fromLevel,
      toLevel: res.energyUnitGroupReqs?.[1]?.toLevel,
    },
    mediumSelection2: res.energyUnitGroupReqs?.[1]?.mediumId,
    displayEnergyName2: res.energyUnitGroupReqs?.[1]?.showEnergyGroupName,
    energyAnalysisGroup3: res.energyUnitGroupReqs?.[2]?.energyGroupId,
    levelRange3: {
      fromLevel: res.energyUnitGroupReqs?.[2]?.fromLevel,
      toLevel: res.energyUnitGroupReqs?.[2]?.toLevel,
    },
    mediumSelection3: res.energyUnitGroupReqs?.[2]?.mediumId,
    displayEnergyName3: res.energyUnitGroupReqs?.[2]?.showEnergyGroupName,
  });
  setCurrentUnitData({
    totalWater: res.energyUnitId1,
    sewageStation: res.energyUnitId2,
    totalWaterEnergyGroupId: res.energyGroupId1,
    sewageStationEnergyGroupId: res.energyGroupId2,
  });
  return res;
}

export const onFinish = async (
  values: any,
  currentUnitData: Record<string, number | undefined>,
  setIsEdit: (v: boolean) => void,
  setRefresh: (fn: (prev: boolean) => boolean) => void,
  message: any
) => {
  await apiV2WaterMapConfigSavePost({
    energyUnitId1: currentUnitData['totalWater'],
    energyUnitId2: currentUnitData['sewageStation'],
    energyGroupId1: currentUnitData['totalWaterEnergyGroupId'],
    energyGroupId2: currentUnitData['sewageStationEnergyGroupId'],
    periodId: values.unWorkTime,
    topologyId: values.energyTopology,
    nodeIds: values.pipeLossNode,
    symbolDisplay: values.symbolDisplay,
    labelIds: values.deviceLabel,
    configurationId: values.waterConfig,
    // energyUnitName2: values.energyUnitName2,
    //  energyUnitName1: values.energyUnitName1,
    energyUnitGroupReqs: [
      {
        energyGroupId: values.energyAnalysisGroup1,
        mediumId: values.mediumSelection1,
        showEnergyGroupName: values.displayEnergyName1,
        fromLevel: values.levelRange1?.fromLevel,
        toLevel: values.levelRange1?.toLevel,
      },
      {
        energyGroupId: values.energyAnalysisGroup2,
        mediumId: values.mediumSelection2,
        showEnergyGroupName: values.displayEnergyName2,
        fromLevel: values.levelRange2?.fromLevel,
        toLevel: values.levelRange2?.toLevel,
      },
      {
        energyGroupId: values.energyAnalysisGroup3,
        mediumId: values.mediumSelection3,
        showEnergyGroupName: values.displayEnergyName3,
        fromLevel: values.levelRange3?.fromLevel,
        toLevel: values.levelRange3?.toLevel,
      },
    ].filter(item => item.energyGroupId),
  });
  message.success('保存成功');
  setIsEdit(false);
  setRefresh(prev => !prev);
};
